<template>
  <div v-if="companyKey === 'BSG'">
    <ReportButton
        v-if="operationType === 'go_work_mobile'"
        :to="{ name: 'privateCoachingGoWorkMobileFirstInterviewForm', params: { id } }"/>

    <ReportButton
        v-else-if="operationType === 'modular_integration_coaching'"
        :to="{ name: 'privateCoachingMicFirstInterviewV2Form', params: { id } }"/>

    <ReportButton
        v-else
        :to="{ name: 'privateCoachingFirstInterviewForm', params: { id } }"/>
  </div>

  <div v-if="companyKey === 'BBQ' || companyKey === 'WAR'">
    <ReportButton
        :to="{ name: 'bbqPrivateCoachingMicFirstInterviewV2Form', params: { id } }"/>
  </div>
</template>

<script setup>
import {defineProps} from 'vue';
import ReportButton from '@/components/button/ReportButton.vue';

defineProps({
  companyKey: {
    type: String,
    required: true
  },
  operationType: {
    type: String,
    default: null
  },
  id: {
    type: [Number, String],
    required: true
  }
})
</script>
